/* 
Scaffolded code: this code was scaffolded by the code generator, feel free to change it 
Template: ViewModel.cst
 */
import { ViewModelService } from 'src/app/shared/view-model.service';
import {
  TimelineItemRecord,
  TimelineItemViewModelBase,
} from 'src/store/generated/timeline-item-record.generated';
import { TimestampTypeRecord } from 'src/store/generated/timestamp-type-record.generated';
import { TimestampTypeViewModel } from './timestamp-type-view-model';

export class TimelineItemViewModel extends TimelineItemViewModelBase {
  public readonly timestampType: TimestampTypeViewModel;

  constructor(
    timeline: TimelineItemRecord,
    timestampType: TimestampTypeRecord,
    private _model: ViewModelService,
  ) {
    super(timeline);
    this.timestampType = new TimestampTypeViewModel(timestampType);
  }
}
